/* eslint-disable no-unused-vars */
enum ERRORS {
  FETCHED_WITH_ERROR = "Fetched error:",
  API_UNDEFINED = "API_URL is not defined in environment variables",
}

export { ERRORS };
